export const convertPermissions = (permissionsList) => {
    return permissionsList.reduce((acc, {name, actions}) => {
        acc[name] = actions.reduce((permissions, {type, hasPermission}) => ({
            ...permissions,
            [type.toLowerCase()]: hasPermission
        }), {});
        return acc;
    }, {});
};